module.exports = __webpack_public_path__ + "static/media/currency.3c894730.svg";